import FilterDiv, { FilterText } from 'components/FilterDiv'
import SearchInput from 'components/SearchInput'
import { TableTop } from 'components/UIComponents/TableSearchFilter/Style/style'
import React from 'react'
import { ShowingTest } from './Style/style'

const TableJobSearchFilter = ({
  menu,
  totalCount = 0,
  currentCount = 0,
  searchValue,
  setSearchValue,
  open,
  setOpen,
  placeholder = 'Search by keyword',
  onOpenChange,
  hideFilter = false,
  customTableHeight = 'unset',
  minWidth,
  filterPosition,
  searchWidth = '20%',
  filterWidth = '60%',
  handleSearch,
  ruleEngine,
  padding,
  width,
}) => {
  return (
    <TableTop
      centerVertically
      customHeight={customTableHeight}
      padding={padding}
      width={width}
    >
      <SearchInput
        width={hideFilter ? '100%' : searchWidth}
        placeholder={placeholder}
        bordered={false}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        handleSearch={handleSearch}
      />
      {hideFilter ? null : (
        <>
          <FilterDiv
            overlayMenu={menu}
            open={open}
            setOpen={setOpen}
            onOpenChange={onOpenChange}
            minWidth={minWidth}
            filterPosition={filterPosition}
            width={filterWidth}
          />
          <FilterText>
            Showing {isNaN(currentCount) ? 0 : currentCount} of {totalCount}
          </FilterText>
        </>
      )}
      {ruleEngine && (
        <ShowingTest>
          <FilterText>
            Showing {isNaN(currentCount) ? 0 : currentCount} of {totalCount}
          </FilterText>
        </ShowingTest>
      )}
    </TableTop>
  )
}

export default TableJobSearchFilter
